import { getUiLocale } from './locale';

const WIKI = 'https://u60z777w08.feishu.cn/wiki/';

const HELP_DOCS = {
  dnsVerify: ['LKd6wdrioiedjqk2j4hcxMdcnc5', 'TrslwDheniGj36kd7EWcd3w4ndP', 'WnQpwI81Ki0wdskABptcXWFEnOb'],
  dynamicDomain: ['IoXXwVUaRi6cuQkWsQTcYPqHnTc', 'IoXXwVUaRi6cuQkWsQTcYPqHnTc', 'IJG0wVEocihGBLkprTIcD3vCn5c'],
  domainPreheat: ['EIzGwjpg0iB5B9kFJYdcf1OUnHg', 'XivnwNqhIi7WnukMXuNcQlJznIc', 'JbEvwU9SWioyn2kdz8gcqoO7nGb'],
  smartFilter: ['BdckwN3ySiwO6yk8lIrcincMnsh', 'EX8CwlkJfiZXQhkQ2fpcqTThnze', 'H7sAw7J4siKIbvkt3fyc0HG1ncc'],
  phoneApply: ['InlIwc0utixZCIkQ1sfcXksFnag', 'TXUFwkV09idxHvk5UTdcOdhvndc', 'TwZZwh5h5iuD0DkEtSacg7gUnZb'],
  unsubscribeKeyword: ['BYQ7wdSG4imVQpkX57mc0WMynrf', 'BLG8wxHyeiCs8okeS52cFRD0nzd', 'NLxbwhK3UiTqjLkoOqycli0RnOe'],
  texasSms: ['JdWHwTPMzivAg3kVkOCcI3R1nXt', 'SXWlwTf1HiYT8Ykj36LcUZLMn4c', 'Ef98w7WiYiu2yGkiLgYcTYUEnMc'],
  quietTime: ['JLOgwumDDi7lbpk0LEwcXy00ngf', 'JLOgwumDDi7lbpk0LEwcXy00ngf', 'Rtq2wjjXdiGm6pkiRZ1ctUgHnUK'],
  quietTimeCompliance: ['KuqfwzzFyiAf0skjqLyc5EXUnPf', 'KuqfwzzFyiAf0skjqLyc5EXUnPf', 'NJj1wMwUziIcCekNrYwcn1pSnuf'],
  iosAppPush: ['QZEfw19cNi3KS0kL8Aacf3dknBc', 'Q8Cnw3ncziKPxEkSFSzcO8e4n2c', 'AihRwJ73liqix4kG5gRcjxVenEd'],
  androidAppPush: ['GoVzwSZL7iO61UkuYI6cBBGDnXf', 'T9MKw94TSinnPDkljj4cAjB2nGf', 'XvGUwwriAicXyskN78Oc6Hkunlg'],
  smsPricing: ['AfrVw3G5mi8f6Pks1ItccFUIn8d', 'AfrVw3G5mi8f6Pks1ItccFUIn8d', 'RYfNwZNXQi1shlkMY8Jclu9onac'],
  quotaExhausted: ['A3T1wBulVi4X6Tk0bonclAKzn5c', 'A3T1wBulVi4X6Tk0bonclAKzn5c', 'BbNAwdN2tipmAwkGatscFP4MnNg'],
  topbarNotice: ['SIu4whVdnipquzkVsXRcxjDcnMg', 'SIu4whVdnipquzkVsXRcxjDcnMg', 'DlFNwwvqHiBCXLkGpiecsBJEn8g'],
  dashboardHelp: ['RLBsw8LfgiN7HMkFSBIcYM05nnF', 'BVnfwjTZ0i7YC4kCIwrchaROnXg', 'R2gZwSO7UidNb7kbrdNcKYDcn1c'],
  subscribeCompliance: ['WwD8wa7dfiWHM8k0ts4cdndUnhc', 'WwD8wa7dfiWHM8k0ts4cdndUnhc', 'Jf5Gw7zmNiktXDkLbzXcwLThnRe'],
  abTestEmail: ['TvtLwFneCi3YpgkJuNEc84ZYnyf', 'AOZrwAoh8i0QsMkuy8gciqyancf', 'Gbm4wW2hNio8kLkrMdgc9qHTnyg'],
  abTestSms: ['EVkpwvwrzivNp7kKiDecnk72nug', 'GwEow9tYMi5XWNkHQpjcTj2YnLF', 'E6zdw8YKZiBfdYk7XIqcvi0Lnah'],
  higherOpenRate: ['WB8gw2uFaik7wHknzVkcpECentb', 'WB8gw2uFaik7wHknzVkcpECentb', 'VRD6wazf1i59QPkm3w1cRTyZnRc'],
  promotionsTab: ['EJEVwa21qidhR1kMs0WcR5qInPg', 'RFOIwLfTCiyMJqkJIS6chpdmnZb', 'CyQowSI3piJ6xokHeRxckiaGnph'],
  campaignRemarketing: ['VfTVwH1MnijMg1kIbjNcUvvNnTb', 'TJzKwkD34iZUc3kiwW0cWLBgnHh', 'VygiwETBviMaqRkNZ3jcZYDInJe'],
  aiGenerateEmail: ['TWVawL0DjiDOGLkSNEzcwmlZnZe', 'U5fcw1zGOisDSyk98cscQlLunHe', 'ZmDXwaogei6B4ak6QvQc97JXn0Q'],
  smartSendAudience: ['Vom5waFmaieyuGk8LmecGLM2nBc', 'CS4ZwzADsiZreMkiAKPc4tBznQe', 'HRfawLY5NilTbYkdzdicprJnnyc'],
  highValueSilent: ['J5IwwIV24i2c1HkLBUJcdLYMn1c', 'J5IwwIV24i2c1HkLBUJcdLYMn1c', 'VeC5wtF8Nissf6k6YxycbIBingc'],
  howToSendSms: ['WUlXwz9tOiKqatkekudcxqPsnSb', 'WUlXwz9tOiKqatkekudcxqPsnSb', 'INU7wrwzPiimkjk6GwBcnMajnHf'],
  autoCampaignGuide: ['BI5uww8yZiZjcYkHBIRcfJ5UnEf', 'PsnSwlaF2iraRakoOl7cHEVTnqe', 'ABFTwBtmLi9moXkgAaNclAm6nOl'],
  dataMetrics: ['Qo0iwVoYLiZo3ckWZXjcwX1KnUf', 'ACvUwg8mCijBBekPlwKcDqPYnrf', 'UcYCwyC2rir54zkRXL3c0D5CnNe'],
  flowRecall: ['QlKawJ2PViH0mTkzrTDc9m34nig', 'QuTBwulotij7bgkDImOcXI7tnpf', 'FpBOwQ6SpijHXhkWcv1cW7sonWf'],
  popupRecall: ['QlKawJ2PViH0mTkzrTDc9m34nig', 'QuTBwulotij7bgkDImOcXI7tnpf', 'FpBOwQ6SpijHXhkWcv1cW7sonWf'],
  webhook: ['IHFLwytpViHokPkJw4acddhWnnb', 'NIUxwFNXTit5Khky5Z9c2xTenkb', 'QfCpwULpAi0NRIkVY0dc5Uixn8b'],
  trustpilot: ['J9EPwuDzBivDvKkNMsncL141nmd', 'B0w6w4BOxivVZ9k7lLccT571ngd', 'KptHwS1V8iuUEXk5IzrclOECn8f'],
  dateProperty: ['MHCswcGadigNzzk8Pnxc1vhGn6r', 'SCQqw9VNYifEh8k9NxMclqSAnXe', 'ZpeRwhFp5i5n5fkSpjMcSFlKnOh'],
  orderDelivered: ['OuIqwc3yMifvCXkDBDXcLRMinTX', 'OuIqwc3yMifvCXkDBDXcLRMinTX', 'U7rbwjz9BiRxA3kOi9scJBgjnIb'],
  splitCondition: ['RumowjUI4iMq2ekoznfcuBxDnBc', 'BgxAw7FDziVumKkp9D5cMiiGnAP', 'ZK0AwZsvXiTfOUkeqBTc4XIintd'],
  filterUpgraded: ['LhROwGfsliJAPCkQ900cvtZcnCb', 'LhROwGfsliJAPCkQ900cvtZcnCb', 'NsoJwFNnNijP8UkSFOPcJmU8n3c'],
  smsEditor: ['GKd1ws9IUiISyEkefxVcjrJlnFc', 'GKd1ws9IUiISyEkefxVcjrJlnFc', 'FoJrwkv9iiVyGvkmj54cmNEnnGf'],
  mmsCountries: ['U9WewmF1nikXpKkFw9icgzivntd', 'U9WewmF1nikXpKkFw9icgzivntd', 'R6pcwGYm2iPQGKkYyPQcPmljnxb'],
  discountCode: ['QovqwZhC1i2nUokLn5Uca9plnyc', 'QovqwZhC1i2nUokLn5Uca9plnyc', 'Jms3wtijcilLwnkAr8HcVGzXn9f'],
  docGuide: ['SirXwVKjSi9UyjkkwZKczI2znkQ', 'SirXwVKjSi9UyjkkwZKczI2znkQ', 'VLSqw7YYCiDupkkYYyucG3Olnbd'],
  phoneFormat: ['Ua3FwbFxui2MYvkI9FRcB72gnWd', 'P8UFwLwQRiGtFbkypc6cWMbUnac', 'OUMswu9HNipKE7klFqjcdnuTngc'],
  subscribeRecord: ['ZqwCwtRvZi6JXFkXcSucCHJSnXe', 'M8Gjwd5loiVZDIkFIGdceGLKnSh', 'Pn8kwXluyi9pcwkJ8XYcIgDfneg'],
  emailSize: ['NGxAw1Fg4i6eZBkWW3uc31qKn3e', 'L5XlwiilSi4afWkIOOEcC1ucnqb', 'K0Hcw5XAsiYDTykm48ycHbajnYf'],
  ampConfig: ['YsSNw8tRqiteDGkq6jPczWrVnoh', 'TOeDwbFEHi8Kkak0cMTcncNbn2d', 'AlVrwdknpi1KOokI9NEchJmfnyd'],
  collectionsLink: ['Ym8NwgFuBi2PmTkuBr8c00T9nkg', 'Ym8NwgFuBi2PmTkuBr8c00T9nkg', 'Li5OwgzqriO0ZlkhzurcsUtynEb'],
  embedForm: ['VeWQww52BiwBNRkhPwqctR1Znxh', 'VeWQww52BiwBNRkhPwqctR1Znxh', 'Cj12w2xaOiYfEFkhwrZc5s1znAb'],
  customTrigger: ['J0amws06Zi1kmpk1Bb4cbcCVnBb', 'J0amws06Zi1kmpk1Bb4cbcCVnBb', 'SjBKwNG0WiWXpskMt9xcnb4ynBb'],
  restockAlert: ['HFAdwDTreilNFhkQ0iLc9Apanxd', 'PfGgwiRV8ivggAkSWc7cm9v2nQd', 'FudRw8jm3if8XHkaHufcXsWQnSP'],
  smsSubscribeDetail: ['X8jDwZzwaiZfKNkgWoUcOt65nNb', 'ZFQpw61Q3ic8vwkvyVlcV6yUnvb', 'TgymwFJsoiHlKqkfIvvcSnxEnaf'],
  // 顶栏「新功能」：中文仍用语雀，英/越用语雀对应飞书页
  whatsNew: [
    'https://www.yuque.com/xuyang-i9idz/nywmyg',
    'FmI1wRXz6iHQLWkGOeYcx2T0nTb',
    'YArswoGSgizXsak14lLc0I6DnGe',
  ],
  // 顶栏知识库：中文仍用语雀，英/越替换原 mingming 语雀
  knowledgeBase: [
    'https://www.yuque.com/mingming-djwpy/uyimlb',
    'HKrAwdHE6ie9lVk96ggcLaVqndc',
    'Bgj1wmsssiaCFPk3LoIcLKmHnFf',
  ],
} as const;

export type HelpDocKey = keyof typeof HELP_DOCS;

function localeIndex() {
  const loc = getUiLocale();
  if (loc === 'en-US') return 1;
  if (loc === 'vi-VN') return 2;
  return 0;
}

const NAVBAR_DOC_KEYS: HelpDocKey[] = ['whatsNew', 'knowledgeBase'];

/** 按当前 UI 语言返回帮助文档飞书链接。中文用语雀对应的飞书中文页。 */
export function helpDoc(key: HelpDocKey): string {
  const id = HELP_DOCS[key][localeIndex()];
  if (id.indexOf('://') !== -1) {
    return id;
  }
  const qs = NAVBAR_DOC_KEYS.indexOf(key) !== -1 ? '?fromScene=spaceOverview' : '';
  return WIKI + id + qs;
}
